<template>
    <q-card style="width: 700px; max-width: 80vw;">
        <q-form @submit.prevent="addOrganization">
            <q-card-section>
                <div class="text-h6">Новая организация</div>
            </q-card-section>

            <q-card-section class="q-pt-none">
                <q-input dense v-model="newOrganization.name" label="Имя организации"
                    :rules="[requiredRule, objectNameRule]" />
            </q-card-section>

            <q-card-actions align="right" class="text-primary">
                <q-btn no-caps flat label="Отмена" color="negative" @click="$emit('cancel')" />
                <q-btn no-caps flat label="Создать" type="submit" />
            </q-card-actions>
        </q-form>

    </q-card>
</template>

<script setup lang="ts">
import { objectNameRule, requiredRule } from "../util/rules";
import { reactive } from "vue";
import { NewOrganization } from "../models/organization";
import { useAddOrganization } from "../composables/organization";

const emits = defineEmits(['add', 'cancel'])


const newOrganization: NewOrganization = reactive({
    name: "",
    code: "",
    description: "",
    typeId: null
})


const { execute } = useAddOrganization(newOrganization)


async function addOrganization() {
    await execute(true)
    emits('add')
}

</script>

<style scoped></style>